// extracted by css-extract-rspack-plugin
export default {"tags":"OAllK_"};